import { css, keyframes } from 'goober';
import React, { lazy, Suspense } from 'react';
import colors from '../../styles/colors';
import font from '../../styles/font';
const Tappable = lazy(() => import(/* webpackChunkName: "Tappable" */ '../Tappable'));
const ANIMATION_DURATION = '2s';
const CoachMarkContainer = css `
  position: absolute;
  text-rendering: optimizeLegibility;
  transform: translate3d(0, 0, 0);
`;
export const CoachMarkSlideRight = keyframes `
  0% {
    width: 22px;
    border-width: 3px;
  }
  10% {
    width: 22px;
    border-width: 3px;
  }
  75% {
    width: 85px;
    border-width: 4px;
  }
  100% {
    width: 22px;
    border-width: 3px;
  }
`;
const CoachMarkFadeOut = keyframes `
  0% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  90% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
`;
const CoachMarkContainerAnimation = css `
  animation: ${CoachMarkFadeOut} ${ANIMATION_DURATION} ease-in infinite;
`;
const CoachMarkCircle = css `
  border: 3px solid ${colors.white};
  width: 22px;
  height: 22px;
  margin: 8px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const SlideRight = css `
  animation: ${CoachMarkSlideRight} ${ANIMATION_DURATION} ease-in infinite;
`;
const TappableBorder = css `
  border-radius: 11px;
`;
const TappableBorderRadius = css `
  border-radius: 50%;
`;
const CoachMarkContent = css `
  font-size: ${font.fontBase};
  font-weight: ${font.fontWtExtraBold};
  color: ${colors.white};
  text-align: right;
  text-transform: capitalize;
`;
const CoachMark = ({ showTransition, CoachMarkStyles, coachMarkText, index, isTappable, }) => {
    const elements = [
        isTappable ? (React.createElement(Tappable, { key: 0 })) : (React.createElement("div", { className: `${CoachMarkCircle} ${showTransition ? SlideRight : ''} ${isTappable ? TappableBorderRadius : TappableBorder}`, key: "circle" })),
        React.createElement("div", { className: `${CoachMarkContent}`, dangerouslySetInnerHTML: {
                __html: coachMarkText,
            }, key: "text" }),
    ];
    return (React.createElement(Suspense, { fallback: React.createElement("div", null, "Loading") },
        React.createElement("div", { "data-position": index, className: `${CoachMarkContainer} ${CoachMarkStyles} ${showTransition ? CoachMarkContainerAnimation : ''} coachmark-container` }, elements.reverse())));
};
export default CoachMark;
//# sourceMappingURL=index.js.map